import React from 'react';
//import CookieConsent from 'react-cookie-consent';
import { HashRouter, Routes, Route } from 'react-router-dom';
import NavBar from './NavBar';
import Home from './Home';
import Nosotros from './Nosotros';
import Servicio from './Servicio';
import Sucursales from './Sucursales';
import Galeria from './Galeria';
import Contacto from './Contacto';
import Footer from './Footer';
import BannerConsentimiento from './services/BannerConsentimiento';
import './App.css';
import './responsive.css';

function App() {
  return (
    <>
    {/*
    import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
    <Router future={{ v7_startTransition: true }}>
      <div className="App">
        <NavBar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/servicio" element={<Servicio />} />
            <Route path="/sucursales" element={<Sucursales />} />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/contacto" element={<Contacto />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    */}
    <HashRouter>
      <div className="App">
        <NavBar />
        <main>

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/servicio" element={<Servicio />} />
            <Route path="/sucursales" element={<Sucursales />} />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/contacto" element={<Contacto />} />
            {/* Add more routes as needed */}
          </Routes>
          </main>
        <BannerConsentimiento/>
        <Footer />
      </div>
    </HashRouter>
    </>
  );
}

export default App;
